// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"15a136cf","913":"b6c2f75f"}[chunkId] + ".chunk.css";
};